/**
 * Post-sign-in redirect targets are attacker-controlled.
 *
 * `/logga-in?next=…` is a link anyone can send. If the value is handed to
 * `redirect()` unchecked, `?next=https://example.com/phish` bounces the browser
 * straight off the Wellday origin — with Wellday as the referrer — which is a
 * ready-made "your session expired, sign in again" phishing primitive.
 *
 * So only an in-app absolute path is ever accepted. Anything else is discarded and
 * the caller falls back to the role's own home.
 */
export function safeNextPath(candidate: string | null | undefined): string | null {
  if (!candidate) return null

  // Must be an absolute in-app path. Relative paths and full URLs are both out.
  if (!candidate.startsWith('/')) return null

  /*
   * "//example.com" and "/\example.com" are protocol-relative URLs: they start
   * with a slash but browsers resolve them to a different origin. Backslashes are
   * normalised to slashes by several browsers, so any backslash is refused rather
   * than reasoned about.
   */
  if (candidate.startsWith('//') || candidate.includes('\\')) return null

  // Control characters (NUL, CR, LF, tab) can smuggle a scheme past the checks
  // above once a browser or proxy strips them.
  if (/[\u0000-\u001f\u007f]/.test(candidate)) return null

  return candidate
}
